<template>
  <div class="margin-spacer">
    <div v-if="item.starring" class="text-details"><strong></strong>{{item.starring}}</div>
    <div v-if="item.genre" class="text-details"><strong></strong>{{item.genre}}</div>
    <div v-if="item.direction" class="text-details"><strong></strong>{{item.direction}}</div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
  .text-details {
    color: gray;
  }
  .margin-spacer {
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>
